import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-68974676"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "banner-container"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "活动入口", -1);
});
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 3,
  class: "info-container"
};
var _hoisted_8 = {
  class: "info-box",
  style: {
    "margin-left": "60px"
  }
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动项", -1);
});
var _hoisted_10 = {
  class: "desc"
};
var _hoisted_11 = {
  class: "info-box info-box-middle"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动里程", -1);
});
var _hoisted_13 = {
  class: "desc"
};
var _hoisted_14 = {
  class: "info-box"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动地址", -1);
});
var _hoisted_16 = {
  class: "desc"
};
var _hoisted_17 = {
  class: "company-box"
};
var _hoisted_18 = {
  key: 0,
  class: "company-unit"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "主办单位：", -1);
});
var _hoisted_20 = {
  key: 1,
  class: "company-unit"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "承办单位：", -1);
});
var _hoisted_22 = {
  key: 2,
  class: "company-unit"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "协办单位：", -1);
});
var _hoisted_24 = {
  key: 3,
  class: "company-unit"
};
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "技术支持：", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  var _component_ExamInfoModal = _resolveComponent("ExamInfoModal");
  var _component_ScienceFair = _resolveComponent("ScienceFair");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: _ctx.item.detailBanner,
    class: "activity-img",
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_ctx.chongqinSpecialActive ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("p", {
    class: "special-btn-apply",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.showFair && _ctx.showFair.apply(_ctx, args);
    })
  }, "科普赛事"), _createElementVNode("p", {
    class: "special-btn-apply",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToUserCenter && _ctx.goToUserCenter.apply(_ctx, args);
    })
  }, "模拟练习"), _createElementVNode("p", {
    class: "special-btn-apply",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToUserCenter && _ctx.goToUserCenter.apply(_ctx, args);
    })
  }, "比赛入口")])) : _ctx.item.buttonText && _ctx.item.showBrandSign === _ctx.showBrand && !_ctx.isHideApplyBtn ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["btn-apply", {
      disable: _ctx.item.buttonId === 4
    }]),
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.onBtnClick && _ctx.onBtnClick.apply(_ctx, args);
    })
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.hideGetCertification ? '参与活动' : _ctx.shangdongSpecialActive ? '去参赛' : _ctx.item.buttonText), 1)], 2)) : _ctx.item.buttonId === 5 && _ctx.inIframe ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "btn-apply",
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToUserCenter && _ctx.goToUserCenter.apply(_ctx, args);
    })
  }, _hoisted_6)) : _createCommentVNode("", true), !_ctx.shangdongSpecialActive && !_ctx.chongqinSpecialActive && !_ctx.hideInfoSpecialActive ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_row, {
    type: "flex",
    justify: "center",
    gutter: 60
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.item.contestItem), 1)])];
        }),
        _: 1
      }), _ctx.item.itemValue ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, _toDisplayString(_ctx.item.itemName), 1), _createElementVNode("div", null, _toDisplayString(_ctx.item.itemValue), 1)])])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_col, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.item.activityArea), 1)])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_ctx.item.holdItemName ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_hoisted_19, _createElementVNode("span", null, _toDisplayString(_ctx.item.holdItemName), 1)])) : _createCommentVNode("", true), _ctx.item.undertakeItemName ? (_openBlock(), _createElementBlock("span", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, _toDisplayString(_ctx.item.undertakeItemName), 1)])) : _createCommentVNode("", true), _ctx.item.assistItemName ? (_openBlock(), _createElementBlock("span", _hoisted_22, [_hoisted_23, _createElementVNode("span", null, _toDisplayString(_ctx.item.assistItemName), 1)])) : _createCommentVNode("", true), _ctx.item.supportItemName ? (_openBlock(), _createElementBlock("span", _hoisted_24, [_hoisted_25, _createElementVNode("span", null, _toDisplayString(_ctx.item.supportItemName), 1)])) : _createCommentVNode("", true)])]), _createVNode(_component_ExamInfoModal, {
    data: _ctx.examInfo
  }, null, 8, ["data"]), _createVNode(_component_ScienceFair, {
    showFlag: _ctx.scienceFairShowFlag,
    onClose: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.scienceFairShowFlag = false;
    })
  }, null, 8, ["showFlag"])]);
}